export const hasRequirePayment = (arrayOfObjects) => {
  return arrayOfObjects?.some((object) => object?.requirePayment === true)
}
